import { defineSlotRecipe } from "@vygruppen/spor-react";

export const moduleRecipe = defineSlotRecipe({
  className: "drops-module",
  slots: ["root", "header", "body"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      minH: "0",
      minW: "400px",
      borderRadius: "sm",
    },
    header: {
      position: "sticky",
      top: "0",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "2",
      flexShrink: "0",
    },
    body: {
      display: "flex",
      flexDirection: "column",
      flex: "1",
      minH: "0",
    },
  },
  variants: {
    size: {
      md: {
        root: { textStyle: "md", backgroundColor: "bg.brand" },
        header: { padding: "12px", backgroundColor: "bg.brand" },
        body: { padding: "12px", paddingTop: "0" },
      },
      lg: {
        root: { textStyle: "lg", backgroundColor: "bg.subtle" },
        header: { padding: "18px", backgroundColor: "bg.subtle" },
        body: { padding: "18px", paddingTop: "0" },
      },
    },
    // NOTE: these keys must match the `Semantics` union Module passes in.
    // Left as no-op overrides for now — add per-semantic slot styles as needed.
    semantic: {
      neutral: {},
      info: {},
      success: {},
      warning: {},
      alarm: {},
    },
  },
  defaultVariants: {
    size: "md",
  },
});
